(() => {
  const configNode = document.getElementById('GFSearchConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const mobile = window.matchMedia('(max-width:749px), (max-height:500px), (min-width:750px) and (max-width:1366px) and (hover:none) and (pointer:coarse)');
  const phone = window.matchMedia('(max-width:749px)');
  const dialog = document.querySelector('[data-gf-search-dialog]');
  const cache = new Map();
  const widgets = new Map();
  let originInput;
  let bodyStyle;
  let scrollPosition = 0;
  let suppressOpen = false;
  let uniqueId = 0;
  const searchURL = (query) => {
    const url = new URL(config.searchUrl, location.origin);
    if (config.previewTheme) url.searchParams.set('preview_theme_id', config.previewTheme);
    url.searchParams.set('q', query.trim());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    return url;
  };
  const syncInputs = (value, source) => widgets.forEach((widget) => { if (widget.input !== source) widget.input.value = value; });
  const viewport = () => {
    if (!dialog.open) return;
    dialog.style.setProperty('--gf-search-viewport-height', `${window.visualViewport?.height || window.innerHeight}px`);
    dialog.style.setProperty('--gf-search-viewport-top', `${window.visualViewport?.offsetTop || 0}px`);
  };
  const closeDialog = (restoreFocus = true) => {
    if (!dialog.open) return;
    suppressOpen = true;
    widgets.get(dialog.querySelector('form'))?.hide();
    dialog.close();
    if (bodyStyle) {
      Object.assign(document.body.style, bodyStyle);
      bodyStyle = null;
      window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    }
    if (restoreFocus && originInput?.isConnected) {
      originInput.focus({ preventScroll: true });
    }
    queueMicrotask(() => { suppressOpen = false; });
  };
  const openDialog = (input, opener = input) => {
    if (suppressOpen || dialog.open) return;
    const navigation = document.querySelector('[data-gf-navigation][open]');
    if (navigation) navigation.querySelector('[data-gf-nav-close]').click();
    originInput = navigation ? document.querySelector('[data-gf-menu-toggle]') : opener;
    widgets.forEach((widget) => widget.hide());
    const modal = widgets.get(dialog.querySelector('form'));
    modal.input.value = input.value;
    scrollPosition = window.scrollY;
    bodyStyle = {};
    ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach((key) => { bodyStyle[key] = document.body.style[key]; });
    Object.assign(document.body.style, { position: 'fixed', top: `-${scrollPosition}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
    dialog.showModal(); viewport(); modal.input.focus(); modal.update();
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-gf-search-open]');
    if (!opener || !mobile.matches) return;
    const input = document.querySelector('[data-gf-store-header] [data-context="header"] [data-gf-search-input]');
    if (!input) return;
    event.preventDefault();
    openDialog(input, opener);
  });
  class SearchWidget {
    constructor(form) {
      this.form = form;
      if (config.previewTheme) { const preview = document.createElement('input'); preview.type = 'hidden'; preview.name = 'preview_theme_id'; preview.value = config.previewTheme; form.append(preview); }
      this.input = form.querySelector('[data-gf-search-input]');
      this.originalPlaceholder = this.input.placeholder;
      this.setPlaceholder();
      this.panel = form.querySelector('[data-gf-search-suggest]');
      this.content = form.querySelector('[data-gf-search-suggest-content]');
      this.status = form.querySelector('[data-gf-search-status]');
      this.all = form.querySelector('[data-gf-search-view-all]');
      this.initial = this.content.innerHTML;
      this.index = -1;
      this.version = 0;
      this.content.id = `GFSearchSuggestions-${++uniqueId}`;
      this.content.setAttribute('role', 'listbox');
      this.content.setAttribute('aria-label', config.viewAll);
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-haspopup', 'listbox');
      this.input.setAttribute('aria-controls', this.content.id);
      this.input.setAttribute('aria-expanded', 'false');
      this.input.addEventListener('focus', () => {
        const navigation = document.querySelector('[data-gf-navigation][open]');
        if (!mobile.matches && navigation && !navigation.contains(form)) {
          navigation.querySelector('[data-gf-nav-close]').click();
          this.input.focus({ preventScroll: true });
        }
        if (mobile.matches && form.dataset.context !== 'modal') openDialog(this.input);
        else this.update();
      });
      this.input.addEventListener('click', () => { if (mobile.matches && form.dataset.context !== 'modal') openDialog(this.input); });
      this.input.addEventListener('input', () => { syncInputs(this.input.value, this.input); this.update(); });
      this.input.addEventListener('keydown', (event) => this.keydown(event));
      this.content.addEventListener('click', (event) => {
        if (event.target.closest('[data-gf-suggest-retry]')) this.update();
      });
      form.addEventListener('focusout', (event) => { if (form.dataset.context !== 'modal' && !form.contains(event.relatedTarget)) this.hide(); });
      form.addEventListener('submit', () => { this.hide(); if (dialog.open) closeDialog(false); });
    }
    show() {
      widgets.forEach((widget) => { if (widget !== this) widget.hide(); });
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.form.style.setProperty('--gf-search-room', `${Math.max(180, innerHeight - this.input.getBoundingClientRect().bottom - 30)}px`);
      const query = this.input.value.trim();
      this.all.href = searchURL(query).href;
      this.all.textContent = query ? config.viewAllQuery.replace('__query__', query) + ' →' : config.viewAll + ' →';
    }
    hide() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.version++;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.index = -1;
    }
    options() { return [...this.content.querySelectorAll('a[href]')]; }
    setPlaceholder() {
      this.input.placeholder = mobile.matches ? (this.form.dataset.context === 'header' ? config.mobileHeaderPlaceholder : config.mobilePlaceholder) : this.originalPlaceholder;
    }
    prepareOptions() {
      this.index = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.content.querySelectorAll('ul').forEach((list) => list.setAttribute('role', 'presentation'));
      this.content.querySelectorAll('li').forEach((item) => item.setAttribute('role', 'presentation'));
      this.options().forEach((link, index) => { link.id = `${this.content.id}-option-${index}`; link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false'); link.tabIndex = -1; });
    }
    state(text, retry = false) {
      this.content.replaceChildren();
      const message = document.createElement('p');
      message.className = 'gf-search-state'; message.textContent = text;
      this.content.append(message);
      if (retry) {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'gf-search-retry'; button.dataset.gfSuggestRetry = ''; button.textContent = config.retry; this.content.append(button);
      }
      this.status.textContent = text;
    }
    update() {
      clearTimeout(this.timer);
      this.controller?.abort();
      const version = ++this.version;
      const query = this.input.value.trim();
      this.show();
      if (!query) { this.content.innerHTML = this.initial; this.prepareOptions(); this.status.textContent = ''; return; }
      this.state(config.loading);
      this.timer = setTimeout(async () => {
        const url = new URL(config.suggestUrl, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,collection');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('section_id', 'gf-search-suggestions');
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          let html = cache.get(query);
          if (!html) {
            const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Suggestions unavailable');
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const result = parsed.querySelector('[data-gf-predictive-results]');
            if (!result) throw new Error('Suggestions unavailable');
            html = result.outerHTML; cache.set(query, html);
            if (cache.size > 20) cache.delete(cache.keys().next().value);
          }
          if (this.version !== version) return;
          this.content.innerHTML = html; this.prepareOptions();
          this.status.textContent = this.options().length ? config.suggestionsCount.replace('__count__', String(this.options().length)) : this.content.textContent.trim();
        } catch (error) {
          if (this.version === version) { this.input.removeAttribute('aria-activedescendant'); this.state(config.suggestionsError, true); }
        } finally { clearTimeout(timeout); }
      }, 220);
    }
    keydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopPropagation();
        if (this.form.dataset.context === 'modal') closeDialog(); else this.hide();
        return;
      }
      const options = this.options();
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (this.panel.hidden) { this.update(); return; }
        if (!options.length) return;
        this.index = event.key === 'ArrowDown' ? (this.index + 1) % options.length : (this.index < 0 ? options.length - 1 : (this.index - 1 + options.length) % options.length);
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.index)));
        this.input.setAttribute('aria-activedescendant', options[this.index].id);
        options[this.index].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && this.index >= 0 && !this.panel.hidden && options[this.index]) {
        event.preventDefault(); options[this.index].click();
      }
    }
  }
  const initWidgets = (scope = document) => scope.querySelectorAll('[data-gf-search-form]').forEach((form) => { if (!widgets.has(form)) widgets.set(form, new SearchWidget(form)); });
  initWidgets();
  document.addEventListener('click', (event) => widgets.forEach((widget) => { if (widget.form.dataset.context !== 'modal' && !widget.form.contains(event.target)) widget.hide(); }));
  dialog.querySelector('[data-gf-search-close]').addEventListener('click', () => closeDialog());
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
    if (event.key === 'Tab') {
      const targets = [...dialog.querySelectorAll('button:not([disabled]),input:not([type=hidden]),a[href]')].filter((element) => element.getClientRects().length && element.tabIndex >= 0);
      const first = targets[0], last = targets[targets.length - 1];
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    }
  });
  mobile.addEventListener('change', () => { closeDialog(); widgets.forEach((widget) => { widget.hide(); widget.setPlaceholder(); }); });
  window.visualViewport?.addEventListener('resize', viewport);
  window.visualViewport?.addEventListener('scroll', viewport);
  window.addEventListener('pagehide', () => { if (dialog.open) closeDialog(false); widgets.forEach((widget) => widget.hide()); });
  let resultController;
  let resultVersion = 0;
  let pendingURL;
  const arrangeFilters = (scope = document) => { const filters = scope.querySelector('[data-gf-search-filters]'); if (filters) filters.open = !phone.matches; const page = scope.matches?.('[data-gf-search-page]') ? scope : scope.querySelector('[data-gf-search-page]'); if (page?.querySelector('[data-gf-search-results-dialog]')) page.classList.add('gf-search-mobile-ready'); };
  arrangeFilters(); phone.addEventListener('change', () => { closeResultsDialog(); arrangeFilters(); });
  const updateResults = async (url, push = true) => {
    let page = document.querySelector('[data-gf-search-page]');
    if (!page) return;
    resultController?.abort();
    resultController = new AbortController();
    const version = ++resultVersion;
    pendingURL = new URL(url, location.origin);
    pendingURL.searchParams.delete('section_id');
    const targetURL = new URL(pendingURL);
    targetURL.searchParams.set('section_id', page.dataset.sectionId);
    if (config.previewTheme) targetURL.searchParams.set('preview_theme_id', config.previewTheme);
    widgets.forEach((widget) => widget.hide());
    page.setAttribute('aria-busy', 'true');
    const errorBox = page.querySelector('[data-gf-search-update-error]');
    const updateStatus = page.querySelector('[data-gf-search-update-status]');
    if (errorBox) errorBox.hidden = true;
    if (updateStatus) updateStatus.textContent = config.updating;
    const timeout = setTimeout(() => resultController.abort(), 10000);
    try {
      const response = await fetch(targetURL, { signal: resultController.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Results unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.querySelector('[data-gf-search-page]');
      if (!next) throw new Error('Results unavailable');
      if (version !== resultVersion) return;
      page.querySelectorAll('[data-gf-search-form]').forEach((form) => { widgets.get(form)?.hide(); widgets.delete(form); });
      closeResultsDialog(false);
      page.replaceWith(next);
      initWidgets(next); arrangeFilters(next);
      if (push) history.pushState({ gfSearch: true }, '', pendingURL);
      document.title = parsed.querySelector('title')?.textContent || document.title;
      const count = next.querySelector(phone.matches ? '[data-gf-mobile-result-count]' : '[data-gf-result-count]');
      if (count) { count.tabIndex = -1; count.focus({ preventScroll: true }); count.scrollIntoView({ block: 'center', behavior: 'instant' }); }
    } catch (error) {
      if (version !== resultVersion) return;
      if (updateStatus) updateStatus.textContent = '';
      if (errorBox) { errorBox.hidden = false; page.querySelector('[data-gf-results-fallback]').href = pendingURL.href; }
      else location.assign(pendingURL);
    } finally { clearTimeout(timeout); if (version === resultVersion) page.removeAttribute('aria-busy'); }
  };
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-gf-search-controls]');
    if (!form) return;
    event.preventDefault();
    const url = new URL(form.action);
    const parameters = new URLSearchParams(new FormData(form));
    [...parameters].forEach(([key, value]) => { if (!value) parameters.delete(key); });
    url.search = parameters;
    updateResults(url);
  });
  document.addEventListener('change', (event) => { if (event.target.matches('[data-gf-search-sort]')) event.target.form.requestSubmit(); });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-gf-search-update]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) { event.preventDefault(); updateResults(link.href); }
    if (event.target.closest('[data-gf-results-retry]') && pendingURL) updateResults(pendingURL);
  });
  window.addEventListener('popstate', () => { if (document.querySelector('[data-gf-search-page]')) updateResults(location.href, false); });
  const pageQuery = document.querySelector('[data-gf-search-page] [name=q]')?.value.trim();
  if (pageQuery && new URLSearchParams(location.search).get('type') !== 'product') {
    const url = new URL(location.href); url.searchParams.set('type', 'product'); location.replace(url);
  }
  let resultDialog;
  let resultOrigin;
  let resultBodyStyle;
  let resultScroll = 0;
  let draftController;
  let draftTimer;
  let draftVersion = 0;
  const closeResultsDialog = (restore = true) => {
    clearTimeout(draftTimer);
    draftController?.abort();
    draftVersion++;
    if (resultDialog?.open) resultDialog.close();
    if (resultBodyStyle) {
      Object.assign(document.body.style, resultBodyStyle);
      resultBodyStyle = null;
      window.scrollTo({top:resultScroll,behavior:'instant'});
    }
    if (restore && resultOrigin?.isConnected) resultOrigin.focus({preventScroll:true});
    resultDialog = null;
  };
  const draftURL = () => {
    const page = resultDialog.closest('[data-gf-search-page]');
    const source = page.querySelector('[data-gf-search-controls]');
    const url = new URL(source.action);
    const params = new URLSearchParams(new FormData(source));
    if (resultDialog.dataset.mode === 'filters') {
      [...params.keys()].filter(key=>key.startsWith('filter.')).forEach(key=>params.delete(key));
      new FormData(resultDialog.querySelector('form')).forEach((value,key)=>{if(key.startsWith('filter.') && value !== '') params.append(key,value);});
    } else params.set('sort_by',resultDialog.querySelector('select').value);
    [...params].forEach(([key,value])=>{if(value==='')params.delete(key);});
    params.delete('page');url.search=params;return url;
  };
  const refreshDraft = () => {
    if (!resultDialog?.open) return;
    const current = resultDialog;
    const status = current.querySelector('[data-gf-search-draft-status]');
    const apply = current.querySelector('[data-gf-search-draft-apply]');
    const retry = current.querySelector('[data-gf-search-draft-retry]');
    clearTimeout(draftTimer);draftController?.abort();const version=++draftVersion;
    const fields=[...current.querySelectorAll('input[type=number]')];
    const min=fields.find(input=>input.name.endsWith('.gte'));
    const max=fields.find(input=>input.name.endsWith('.lte'));
    const invalid=fields.some(input=>!input.validity.valid)||(min?.value!=='' && max?.value!=='' && min && max && Number(min.value)>Number(max.value));
    retry.hidden=true;apply.disabled=true;
    if(invalid){status.textContent=current.dataset.priceError;return;}
    status.textContent=config.updating;
    draftTimer=setTimeout(async()=>{
      draftController=new AbortController();
      const abort=draftController;
      const timeout=setTimeout(()=>abort.abort(),10000);
      const url=draftURL();url.searchParams.set('section_id',current.closest('[data-gf-search-page]').dataset.sectionId);
      if(config.previewTheme)url.searchParams.set('preview_theme_id',config.previewTheme);
      try{
        const response=await fetch(url,{signal:abort.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw Error('Unavailable count');
        const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
        const count=parsed.querySelector('[data-gf-result-count]');
        if(!count)throw Error('Missing count');
        if(version!==draftVersion||!current.open)return;
        status.textContent=count.textContent.trim();
        apply.textContent=current.dataset.showResults+' · '+count.textContent.trim();
        apply.disabled=false;
      }catch(error){if(version===draftVersion&&current.open){status.textContent=current.dataset.countError;retry.hidden=false;}}
      finally{clearTimeout(timeout);}
    },180);
  };
  const openResultsDialog = (button) => {
    const page=button.closest('[data-gf-search-page]');
    resultDialog=page.querySelector('[data-gf-search-results-dialog]');
    const current=resultDialog;
    current.dataset.mode=button.dataset.gfSearchOpenControls;
    resultOrigin=button;
    const body=current.querySelector('[data-gf-search-mobile-fields]');body.replaceChildren();
    const filters=current.dataset.mode==='filters';
    current.querySelector('h2').textContent=filters?current.dataset.filtersTitle:current.dataset.sortTitle;
    current.querySelector('[data-gf-search-draft-clear]').hidden=!filters;
    if(filters) page.querySelectorAll('[data-gf-search-filters] fieldset').forEach(fieldset=>body.append(fieldset.cloneNode(true)));
    else {
      const select=page.querySelector('[data-gf-search-sort]').cloneNode(true);
      select.removeAttribute('data-gf-search-sort');
      const label=document.createElement('label');label.textContent=current.dataset.sortTitle;label.htmlFor=select.id;body.append(label,select);
    }
    body.querySelectorAll('[id]').forEach(element=>{const previous=element.id;element.id+='-mobile';body.querySelectorAll('label[for]').forEach(label=>{if(label.htmlFor===previous)label.htmlFor=element.id;});});
    resultScroll=scrollY;resultBodyStyle={};
    ['position','top','left','right','width','overflow'].forEach(key=>resultBodyStyle[key]=document.body.style[key]);
    Object.assign(document.body.style,{position:'fixed',top:`-${resultScroll}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
    current.style.setProperty('--gf-results-viewport',`${visualViewport?.height||innerHeight}px`);
    current.style.setProperty('--gf-results-top',`${visualViewport?.offsetTop||0}px`);
    current.showModal();current.querySelector('[data-gf-search-controls-close]').focus();
    const apply=current.querySelector('[data-gf-search-draft-apply]');apply.disabled=false;
    const count=page.querySelector('[data-gf-result-count]').textContent.trim();
    apply.textContent=current.dataset.showResults+' · '+count;
    current.querySelector('[data-gf-search-draft-status]').textContent='';
    current.querySelector('[data-gf-search-draft-retry]').hidden=true;
    if(!current.dataset.bound){
      current.dataset.bound='true';
      current.addEventListener('cancel',event=>{event.preventDefault();closeResultsDialog();});
      current.addEventListener('close',()=>{if(resultDialog===current)closeResultsDialog();});
      current.addEventListener('keydown',event=>{
        if(event.key!=='Tab')return;
        const targets=[...current.querySelectorAll('button:not([disabled]),input:not([disabled]),select:not([disabled])')].filter(element=>element.getClientRects().length);
        const first=targets[0],last=targets[targets.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
    }
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-gf-search-open-controls]');
    if(button){openResultsDialog(button);return;}
    if(event.target.closest('[data-gf-search-controls-close]')){closeResultsDialog();return;}
    if(event.target.closest('[data-gf-search-draft-retry]'))refreshDraft();
    if(event.target.closest('[data-gf-search-draft-clear]')){
      resultDialog.querySelectorAll('input').forEach(input=>{if(input.type==='checkbox')input.checked=false;else input.value='';});refreshDraft();
    }
  });
  document.addEventListener('input',event=>{if(event.target.closest('[data-gf-search-mobile-fields]'))refreshDraft();});
  document.addEventListener('change',event=>{if(event.target.closest('[data-gf-search-mobile-fields]'))refreshDraft();});
  document.addEventListener('submit',event=>{
    if(!event.target.matches('[data-gf-search-mobile-controls]'))return;
    event.preventDefault();if(resultDialog.querySelector('[data-gf-search-draft-apply]').disabled)return;
    const url=draftURL();closeResultsDialog(false);updateResults(url);
  });
  window.visualViewport?.addEventListener('resize',()=>{
    if(!resultDialog?.open)return;
    resultDialog.style.setProperty('--gf-results-viewport',`${visualViewport.height}px`);
    resultDialog.style.setProperty('--gf-results-top',`${visualViewport.offsetTop}px`);
  });
  window.addEventListener('pagehide',()=>closeResultsDialog(false));

  document.addEventListener('shopify:section:load', (event) => { initWidgets(event.target); arrangeFilters(event.target); });
})();


